(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfUserDialogController', ConsInfUserDialogController);

    ConsInfUserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'ConsInfUser', 'User', 'VisioneConsenso', 'ConsInfAccount'];

    function ConsInfUserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, ConsInfUser, User, VisioneConsenso, ConsInfAccount) {
        var vm = this;

        vm.consInfUser = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();
        vm.visioneconsensos = VisioneConsenso.query();
        vm.consinfaccounts = ConsInfAccount.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.consInfUser.id !== null) {
                ConsInfUser.update(vm.consInfUser, onSaveSuccess, onSaveError);
            } else {
                ConsInfUser.save(vm.consInfUser, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:consInfUserUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
